import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Header } from "../components/Header";
import { PublicFooter } from "../components/PublicChrome";
import { useSeo } from "../lib/seo";

const LINKS = [["/design", "Design a shield"], ["/gaa", "GAA shields"], ["/soccer", "Soccer shields"], ["/rugby", "Rugby shields"], ["/gift", "Gift vouchers"], ["/counties", "Counties & provinces"]];

export default function NotFound() {
  const nav = useNavigate();
  useSeo({ title: "Page not found | sportsshields.ie", description: "Sorry, we couldn't find that page.", noindex: true });
  return (
    <div className="min-h-screen">
      <Header onNew={() => nav("/design")} />
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:py-24" data-testid="not-found-page">
        <p className="font-display text-sm font-black uppercase tracking-widest text-lime-700">Error 404</p>
        <h1 className="font-display mt-2 text-4xl font-black uppercase leading-none tracking-tight sm:text-5xl lg:text-6xl" data-testid="not-found-title">Page not found</h1>
        <p className="mt-4 text-slate-600">That address doesn't exist, or the page has moved. Try one of these instead:</p>
        <ul className="mt-6 grid gap-2 sm:grid-cols-2">
          {LINKS.map(([to, l]) => (
            <li key={to}>
              <Link to={to} className="card-lift flex items-center justify-between border-2 border-slate-900 bg-white px-4 py-3 font-bold" data-testid={`not-found-link-${to.slice(1)}`}>{l} <ArrowRight className="h-4 w-4" /></Link>
            </li>
          ))}
        </ul>
        <Link to="/" className="mt-8 inline-block font-semibold text-lime-700 underline" data-testid="not-found-home">Back to the homepage</Link>
      </main>
      <PublicFooter />
    </div>
  );
}
